// 权限控制
import router from "./router";
import { getToken, removeToken, removeuserInfo } from "./utils/utils";

const WHITE_LIST = ["/login"];

/**
 * 尝试解码 JWT 并检查是否过期
 * @param {string} token
 * @returns {boolean} true = 已过期
 */
function isTokenExpired(token) {
  try {
    // JWT 格式: header.payload.signature
    const payload = token.split(".")[1];
    if (!payload) return false; // 非 JWT 格式，跳过检查

    const decoded = JSON.parse(atob(payload));
    if (!decoded.exp) return false; // 无过期时间，跳过检查

    // exp 是秒级时间戳，加 60s 缓冲防止服务器时间差异
    return Date.now() >= (decoded.exp - 60) * 1000;
  } catch {
    return false; // 解码失败，当作未过期处理（非 JWT token）
  }
}

router.beforeEach((to, from, next) => {
  const token = getToken();

  if (token) {
    // 检查 token 是否过期
    if (isTokenExpired(token)) {
      removeToken();
      removeuserInfo();
      next("/login");
      return;
    }
    next();
  } else {
    if (WHITE_LIST.includes(to.path)) {
      next();
    } else {
      next("/login");
    }
  }
});
